import { Outlet } from 'react-router-dom';

function CarouselSlidesLayout() {
	return <Outlet />;
}

export default CarouselSlidesLayout;
